import ThermalPrinterBase from "../../services/thermalPrinter/ThermalPrinterBase";
import PrintCustomNiceloopV1Builder from "~/class/printer/PrintCustomNiceloopV1Builder";


export default class ThermalPrintOpenMenuReport extends ThermalPrinterBase {  
    printOpenMenu(payload:any){   
            const openMenu = this.withPayload(payload) 
            console.log("openMenu=>", openMenu)
            this.print_data = openMenu
            return this
    }

    withPayload(payload:any){
      const newPayload = this.computePayload(payload) 
      return new PrintCustomNiceloopV1Builder().makeOpenMenuReport(newPayload).build(); 
    }

  setPayload(payload: any){
    this.print_data = payload
    return this
  }

  computePayload(payload: any){
    const goodBills = payload.receipts.filter((r: any) => !r?.IsDeleted);
            const flatGoodbill =goodBills.flatMap((r:any) => r.OrderItems)
            console.log("flatGoodbill=>", flatGoodbill)
            const openMenuProductData = goodBills.flatMap((r:any) => r.OrderItems)
            .reduce((acc:any, item:any) => {
              const existing = acc.find((i:any) => i.subItemId === item.subItemId);
              if (existing) {
                existing.extendedPrice += item.extendedPrice;
                existing.quantity += item.quantity;
              } else {            
                if(item.isOpenMenu || item.name.includes("Open Menu")){
                    acc.push({
                    subItemId: item.subItemId,
                    name: item.name,
                    extendedPrice: item.extendedPrice,
                    price:item.price,
                    quantity: item.quantity,                              
                    });
                }
    
              }
              return acc;
            }, [] as { subItemId: number, name: string, extendedPrice: number, quantity: number }[]);  
    
            const newPayload ={
                shopName:payload.store.name || "My Shop",
                employee:payload.employee,
                openMenuData:openMenuProductData,
                isCloseShop:payload.isCloseShop,
                isChangeShift:payload.isChangeShift
            }

            return newPayload
  }
}
